import { Button, Popover } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import './ListingDropdown.css'
import { ExpandMore } from '@material-ui/icons'
import {
    mapData,
    dateFormatFunction,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '@/product/common/components'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import Popup from '../../organisms/Popup'
import CustomDialog from '@/custom/components/organisms/Dialog'
const ListingDropdown = (props) => {
    const [anchorEl, setAnchorEl] = useState(null)
    const [filterModal, setFilterModal] = useState(null)
    const [searchText, setSearchText] = useState('')
    const [selectedLabel, setSelectedLabel] = useState(props.label)
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }
    const open = Boolean(anchorEl)
    const id = open ? 'simple-popover' : undefined
    const filteredOptions = props.options.filter((option) => {
        if (!option.description) {
            return false
        }
        const optionLabel = option.description.toLowerCase()
        const searchQuery = searchText.toLowerCase()
        return optionLabel.includes(searchQuery)
    })

    const dateRange = [
        {
            label: 'From Date ',
            placeholder: 'MM-DD-YYYY HH:MM',
            type: 'datetime',
            disablePast: true,
            filter: true,
            icon_only: true,
            class: 'col-6',
            upperLabel: true,
            name: 'date_added',
            formik: props.formik,
        },
        {
            label: 'To Date ',
            placeholder: 'MM-DD-YYYY HH:MM',
            disablePast: true,
            filter: true,
            upperLabel: true,
            icon_only: true,
            type: 'datetime',
            class: ' col-6 ',
            name: 'date_closed',
            minDate: dateTimeFormatFunction(props.formik.values?.filters?.date_added?.value || ''),
            minDateMessage: `Date should not be before minimal date ${dateTimeFormatFunction(
                props.formik.values?.filters?.date_added?.value || '',
            )}`,

            formik: props.formik,
        },
    ]

    const formikValues = props?.data?.filter
        ? props?.formik?.values?.filters[`${props?.data?.name}`] || ''
        : props?.formik?.values[`${props?.data?.name}`] || ''

    useEffect(() => {
        if (formikValues) {
            if (props.data.type == 'select') {
                if (formikValues == 'p.date_closed,ASC' && props.data.name == 'orderby') {
                    setSelectedLabel('Ending Soonest')
                } else if (formikValues == '20' && props.data.name == 'orderby') {
                    setSelectedLabel("Today's Steals")
                } else if (formikValues == '21' && props.data.name == 'orderby') {
                    setSelectedLabel('Popular')
                } else {
                    const selected = props.options?.find((x) => x.value === formikValues)?.show
                    setSelectedLabel(selected)
                }
            }
        }
    }, [formikValues])

    const handleDateFilter = () => {
        setFilterModal(!filterModal)

        if (props.formik.values.filters?.date_added?.value) {
            props.formik.setFieldValue(`filters.date_added.value`, '')
            props.formik.values.filters.date_added.value = ''
        }
        if (props.formik.values?.filters?.date_closed?.value) {
            props.formik.setFieldValue(`filters.date_closed.value`, '')
            props.formik.values.filters.date_closed.value = ''
        }
    }

    return (
        <div className="listingDropdown">
            {props.data.calender ? (
                <Button aria-describedby={id} onClick={() => setFilterModal(true)}>
                    <span className="material-icons">calendar_month</span>
                </Button>
            ) : (
                <Button aria-describedby={id} onClick={handleClick}>
                    {selectedLabel}
                    <ExpandMore />
                </Button>
            )}
            <Popover
                id={id}
                anchorEl={anchorEl}
                onClose={handleClose}
                className={`${props.label}Drops ListDropi`}
                open={open}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <div style={{ padding: '10px 0px' }}>
                    {props?.data?.enableSearch && (
                        <div className="headerSearchForm">
                            <input
                                type="text"
                                placeholder="Search options..."
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                            />
                            <button className="search-icon">
                                <img src="/assets/svg/search.svg" />
                            </button>
                            {searchText && (
                                <button className="clear-icon" onClick={() => setSearchText('')}>
                                    <img src="/assets/svg/closeIcon.svg" />
                                </button>
                            )}
                        </div>
                    )}
                    <ul>
                        {props.data?.filter ? (
                            <>
                                {filteredOptions.map((option, index) => (
                                    <li
                                        key={index}
                                        onClick={(event) => {
                                            const newValue = formikValues?.value?.includes(
                                                option?.value,
                                            )
                                                ? formikValues?.value?.filter(
                                                      (v) => v !== option?.value,
                                                  )
                                                : [...formikValues?.value, option?.value].filter(
                                                      (v) => v !== '',
                                                  )
                                            props.handleFormikChange(null, newValue)
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {props.data?.filter && (
                                            <input
                                                onChange={(event) => {
                                                    const newValue = formikValues?.value?.includes(
                                                        option?.value,
                                                    )
                                                        ? formikValues?.value?.filter(
                                                              (v) => v !== option?.value,
                                                          )
                                                        : [
                                                              ...formikValues?.value,
                                                              option?.value,
                                                          ].filter((v) => v !== '')
                                                    props.handleFormikChange(null, newValue)
                                                }}
                                                onClick={(e) => e.stopPropagation()}
                                                type="checkbox"
                                                checked={
                                                    formikValues?.value?.includes(option?.value) ||
                                                    false
                                                }
                                            />
                                        )}
                                        {option.show}
                                    </li>
                                ))}
                            </>
                        ) : (
                            <>
                                {props.options.map((option, index) => (
                                    <li
                                        key={index}
                                        onClick={(event) => {
                                            props.handleFormikChange(event, option.value)
                                            setSelectedLabel(option.show)
                                            handleClose()
                                        }}
                                        style={{ cursor: 'pointer' }}
                                        className={`${
                                            formikValues === option.value ? 'active' : ''
                                        }`}
                                    >
                                        {option.show}
                                    </li>
                                ))}
                            </>
                        )}
                    </ul>
                </div>
            </Popover>
            <CustomDialog
                className="dateRangeDialog"
                open={filterModal}
                function={() => setFilterModal(false)}
                title={'Search date range'}
                disableBackdropClick={true}
            >
                <div className="row">{Object.values(mapData(dateRange))}</div>{' '}
                <div className="filterBtnGrp">
                    <PrimaryButton
                        className=""
                        btnSize="small"
                        id="checkout_pay_make"
                        onClick={() => {
                            let isValue = false
                            if (props.formik.values.filters?.date_added?.value) {
                                props.formik.setFieldValue(`filters.date_added.value`, '')
                                props.formik.values.filters.date_added.value = ''
                                isValue = true
                            }
                            if (props.formik.values?.filters?.date_closed?.value) {
                                props.formik.setFieldValue(`filters.date_closed.value`, '')
                                props.formik.values.filters.date_closed.value = ''
                                isValue = true
                            }
                            if (isValue) {
                                props.formik.values.infinite = false
                                props.formik.values.page = 1
                                props.formik.setFieldValue('page', 1)
                                props.formik.handleSubmit()
                            }

                            setFilterModal(false)
                        }}
                        // disabled={props.isCouponLoading}
                        label={'Clear'}
                    />
                    <PrimaryButton
                        btnSize="small"
                        id="checkout_pay_make"
                        onClick={() => {
                            if (
                                props.formik.values.filters?.date_added?.value ||
                                props.formik.values?.filters?.date_closed?.value
                            ) {
                                props.formik.values.infinite = false
                                props.formik.values.page = 1
                                props.formik.setFieldValue('page', 1)
                                props.formik.handleSubmit()
                            }

                            setFilterModal(false)
                        }}
                        // disabled={props.isCouponLoading}
                        label={'Apply'}
                    />
                </div>
            </CustomDialog>
        </div>
    )
}

export default ListingDropdown
